/* eslint-disable no-console */
import { createStore, createHook, defaults } from 'react-sweet-state';
import moment from 'moment-timezone';
import { DataServiceFactory } from '../services/ApiDataService';

// Integrate react-sweet-state with the redux dev tools.
defaults.devtools = true;

let latestSystemOffset = 0;

export function isServerClientInSync() {
    return inSync(latestSystemOffset);
}

export function formatTimeOffset(useOffset = latestSystemOffset) {
    return formatTime(useOffset);
}

export function isServerBehindClient() {
    return isBehind(latestSystemOffset);
}

export function getSystemTime() {
    return currentMoment(latestSystemOffset);
}

/**
 * Threshold for allowable server/client time difference
 * @returns {boolean}
 */
function inSync(offsetToTest) {
    // 10 minutes for now.  No reason to confuse things unless we are really off.
    const offsetTooBig = 600000;
    return Math.abs(offsetToTest) < offsetTooBig;
}

function formatTime(offsetToTest) {
    return moment.duration(Math.abs(offsetToTest / 1000), 'seconds').humanize();
}

function isBehind(offsetToTest) {
    return offsetToTest < 0;
}

function currentMoment(offsetToTest) {
    return moment().add(offsetToTest, 'ms').utc();
}

function scheduleRefresh(dispatch) {
    const intervalMs = 60000;
    setTimeout(() => dispatch(syncSystemTime()), intervalMs);
}

function syncSystemTime(refresh = true) {
    const startTime = moment().valueOf();
    return ({ setState, dispatch }) => {
        return DataServiceFactory()
            .get(`/ipm/public/systime`)
            .then((result) => {
                const endTime = moment().valueOf();
                const { utcMs } = result;
                const adjUtcMs = utcMs + (endTime - startTime) / 2; // add half of the time it took to make this request
                const lastOffset = adjUtcMs - endTime;
                setState({
                    systemOffset: lastOffset,
                });

                // Set our global
                latestSystemOffset = lastOffset;

                if (refresh) scheduleRefresh(dispatch);
            })
            .catch((error) => console.error('Error refreshing system time', error));
    };
}

const Store = createStore({
    name: 'SystemTime',

    initialState: {
        systemOffset: 0,
    },

    actions: {
        syncSystemTime,
    },
});

export const useServerClientInSync = createHook(Store, {
    selector: (state) => inSync(state.systemOffset),
});

export const useFormatTimeOffset = createHook(Store, {
    selector: (state) => formatTime(state.systemOffset),
});

export const useServerBehindClient = createHook(Store, {
    selector: (state) => isBehind(state.systemOffset),
});

const useSystemTime = createHook(Store);
export default useSystemTime;
